export const HASH_MAIN_CONTENT              = "#main__content";
export const BASE_URL                       = { pathname: '/'};
//export const BROWSE_URL                     = { pathname:'/browse', hash: HASH_MAIN_CONTENT};
export const SUPPORT_URL                    = { pathname:'/support', hash: HASH_MAIN_CONTENT};
export const ABOUT_US_URL                   = { pathname:'/about-us', hash: HASH_MAIN_CONTENT};
export const PRICE_URL                      = { pathname:'/price', hash: HASH_MAIN_CONTENT};
export const FAQ_INSTALL_URL                        = { pathname:'/faq', hash: HASH_MAIN_CONTENT};
//export const LICENSES_URL                   = { pathname:'/licenses', hash: HASH_MAIN_CONTENT};
export const CONTACTS_URL                   = { pathname:'/contact-us', hash: HASH_MAIN_CONTENT};
export const RETURN_POLICY_URL              = { pathname:'/return-policy', hash: HASH_MAIN_CONTENT};
export const COOKIE_POLICY_URL              = { pathname:'/cookie-policy', hash: HASH_MAIN_CONTENT};
export const PRIVACY_POLICY_URL             = { pathname:'/privacy-policy', hash: HASH_MAIN_CONTENT};
export const TERMS_CONDITIONS_URL           = { pathname:'/terms-conditions', hash: HASH_MAIN_CONTENT};
export const KEYMAKER_URL                   = { pathname:'/key-maker'};

/* AUTHORISATION */
export const RESET_PASS_CONFIRM_URL         = { pathname:'/account/password/confirm/*'};
export const RESET_PASS_REJECT_URL          = { pathname:'/account/password/reject/*'};
export const LOGIN_URL                      = { pathname:'/login', hash: HASH_MAIN_CONTENT};
export const SIGNUP_URL                     = { pathname:'/signup', hash: HASH_MAIN_CONTENT};
export const ACTIVATED_SUCCESS_URL          = { pathname:'/activate/success', hash: HASH_MAIN_CONTENT};

/* IS AUTH */
//export const CART_URL                       = { pathname:'/cart', hash: HASH_MAIN_CONTENT};
//export const CHECKOUT_URL                   = { pathname:'/checkout', hash: HASH_MAIN_CONTENT};
//export const PAYMENT_STATUS_URL             = { pathname: CHECKOUT_URL.pathname.concat('/status'), hash: HASH_MAIN_CONTENT};
export const GET_PLUGIN_URL                 = { pathname:'/plugin', hash: HASH_MAIN_CONTENT};

/* USER */
export const USER_URL                       = { pathname:'/user'};
export const USER_BILLS_URL                 = { pathname: USER_URL.pathname.concat('/bills')};
export const USER_SETTINGS_URL              = { pathname: USER_URL.pathname.concat('/settings')};
export const USER_PASSWORD_URL              = { pathname: USER_URL.pathname.concat('/password')};

/* ADMIN */
export const USERS_URL                      = { pathname:'/users'};
export const MANAGEMENT_SETTINGS_URL        = { pathname:'/management/settings'};
 
export const ADMIN_URL                      = { pathname:'/admin', hash: HASH_MAIN_CONTENT};
export const ADMIN_USERS_URL                = { pathname: ADMIN_URL.pathname.concat(USERS_URL.pathname), hash: HASH_MAIN_CONTENT, search: '?page=1&limit=30'};
export const ADMIN_LOGIN_URL                = { pathname: ADMIN_URL.pathname.concat(LOGIN_URL.pathname)};
//export const ADMIN_USER_BILLS_URL           = { pathname: ADMIN_URL.pathname.concat(USER_BILLS_URL.pathname), search: '?page=1&limit=20'};
export const ADMIN_USER_SETTINGS_URL        = { pathname: ADMIN_URL.pathname.concat(USER_SETTINGS_URL.pathname)};
export const ADMIN_USER_PASSWORD_URL        = { pathname: ADMIN_URL.pathname.concat(USER_PASSWORD_URL.pathname)};
export const ADMIN_MANAGEMENT_SETTINGS_URL  = { pathname: ADMIN_URL.pathname.concat(MANAGEMENT_SETTINGS_URL.pathname)};
 
export const NOT_FOUND_URL                  = { pathname: '*'};
